import { TrainingType } from '../../enums';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models';

export function getTrainingType(trainingType: TrainingType): string {
  switch (trainingType) {
    case TrainingType.PerformanceCategories:
      return 'Performance Categories';
    case TrainingType.Skills:
      return 'Skills';
  }
}

export function getTrainingTypeList(): IdName[] {
  return enumToList(TrainingType, getTrainingType);
}
